export default function Loading({
  position = "fixed",
  subParentPosition,
}: any) {
  return (
    <div id="preloader" style={{ position: position }}>
      <div
        id="loader"
        className="loader"
        style={{ position: subParentPosition }}
      >
        <div className="loader-container">
          <div className="loader-icon">
            <img src="/assets/img/logo/pre-load.svg" alt="Preloader" />
          </div>
        </div>
      </div>
    </div>
  );
}
